import 'primereact/resources/themes/lara-light-indigo/theme.css'

//core
import 'primereact/resources/primereact.min.css'

//icons
import 'primeicons/primeicons.css'

//flex
import 'primeflex/primeflex.css'

import './styles/App.css'
import './styles/styles.css'
import './styles/icons.css'
import './styles/bootstrap.3.3.7.min.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'

import Grid from './components/Grid'

import Popup from './components/Popup'
import EQCFromData from './components/forms'
import Login from './components/login'
import UserManagement from './components/usermanagement'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import { Divider } from 'primereact/divider'
import useToken from './components/useToken'
import { useEffect, useState } from 'react'
import { SplitButton } from 'primereact/splitbutton'
import Navbar from 'react-bootstrap/Navbar'
import { Container, Nav, NavDropdown } from 'react-bootstrap'
import logo from '../src/styles/images/image.png'


function App() {
  const [loginUserName, setUserName] = useState(null)
  const { accounts, setToken } = useToken()
  const [srsClassName, setSRSClass] = useState('')
  const [requestClass, setRequestClass] = useState(
    'padding-top-6 padding-bottom-6',
  )
  const [usrClassName, setUsrClass] = useState('')
  const items = [
    {
      label: 'Logout',
      icon: 'pi',
      command: () => {
        setUserName(null)
        localStorage.clear()
      },
    },
  ]

  useEffect(() => {
    if (!accounts) {
      //return <Login setToken={setToken} />
    } else {
      setUserName('Hello, ' + accounts[0].name)
      
    }

    if (window.location.pathname == '/manageusers') {
      setUsrClass('active')
      setRequestClass('padding-top-6 padding-bottom-6')
      setSRSClass('')
    } else if (window.location.pathname == '/requestinfo') {
      setUsrClass('')
      setRequestClass('active')
      setSRSClass('')
    } else if (window.location.pathname == '/SRSPDF') {
      setUsrClass('')
      setRequestClass('')
      setSRSClass('active')
    }
  }, [accounts])

  const srsClick = () => {
    setUsrClass('')
    setRequestClass('')
    setSRSClass('active')
  }

  const reqClick = () => {
    setUsrClass('')
    setRequestClass('active')
    setSRSClass('')
  }

  const usrClick = () => {
    setUsrClass('active')
    setRequestClass('padding-top-6 padding-bottom-6')
    setSRSClass('')
  }
  const user_logout = () => {
    //setToken(null)
    setUserName(null)
    localStorage.clear()
  }

  return (
    <div>
      {loginUserName == null ? (
        <Login setToken={setToken} />
      ) : (
        <Router>
          <header>
            <div className="header-Info">
              <Navbar className="user-dropdown">
                <Container fluid>
                  <Navbar.Toggle aria-controls="navbar-dark-example" />
                  <Navbar.Collapse id="navbar-dark-example">
                    <Nav>
                      <NavDropdown
                        id="nav-dropdown-dark-example"
                        title={loginUserName}
                      >
                        <NavDropdown.Item onClick={user_logout}>
                          Sign Out
                        </NavDropdown.Item>
                      </NavDropdown>
                    </Nav>
                  </Navbar.Collapse>
                </Container>
              </Navbar>
            </div>
          </header>
          <div className="container-page container-fluid">
            <div className="flex-xl-nowrap height-100 row">
              <div className="react-bootstrap-drawer d-flex flex-column side-bar col-lg-2 col-md-3 col-12">
                <a className="navbar-brand" href="/">
                  <img src={logo} alt="BigCo Inc. logo" className="img-30" />
                </a>
                <div className="d-block nav">
                  <ul className='text-align-left'>
                    <li>
                      <Link
                        to="/SRSPDF"
                        className={srsClassName}
                        onClick={srsClick}
                      >
                        <i className="icon icon-upload"></i>
                        QC Automation
                        
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/requestinfo"
                        className={requestClass}
                        onClick={reqClick}
                      >
                         <i className="icon icon-sort-down"></i>
                         Requests
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/manageusers"
                        className={usrClassName}
                        onClick={usrClick}
                      >
                        <i className="icon icon-settings"></i>
                        Users List
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-10 col-md-9 col-12">
                <div className="page-load">
                  <Routes>
                    <Route
                      path="/"
                      element={<Popup />}
                    ></Route>
                    <Route path="/SRSPDF" element={<Popup />}></Route>
                    <Route path="/requestinfo" element={<Grid />}></Route>
                    <Route
                      path="/manageusers"
                      element={<UserManagement />}
                    ></Route>
                  </Routes>
                </div>
              </div>
            </div>
          </div>
        </Router>
      )}
    </div>
  )
}

export default App
